export default __webpack_public_path__ + "static/media/Emotional Turbulence.7dc87438.png";